import styled from '@emotion/styled'
import tokens from '@lacedltd/design-tokens'
import { Accordion, Typography } from '@lacedltd/laced-components'

type TableRowHeaderProps = {
  width: number
}

type BreakdownRowProps = {
  hasBorder?: boolean
}

export const TableRowHeader = styled.th<TableRowHeaderProps>(({ width }) => ({
  width: `${width}%`
}))

export const BreakdownRow = styled.tr<BreakdownRowProps>(
  ({ hasBorder = true }) => ({
    borderTop: hasBorder
      ? `${tokens.borderWidth.xs} solid ${tokens.color.airJordan[400]}`
      : 'none',
    color: tokens.color.airJordan[600]
  })
)

export const DetailedBreakdownRow = styled.tr({
  overflowWrap: 'anywhere',
  verticalAlign: 'top',
  color: tokens.color.airJordan[500]
})

export const AccordionRoot = styled(Accordion.Root)({
  width: 'auto',
  marginLeft: `-${tokens.spacing[6]}`,
  marginRight: `-${tokens.spacing[6]}`
})

export const AccordionItem = styled(Accordion.Item)({
  fontSize: tokens.fontSize[2]
})

export const AccordionTitle = styled(Typography.Text)({
  margin: 0
})

export const BreakdownTable = styled.table({
  width: '100%',

  td: {
    verticalAlign: 'top',
    paddingRight: tokens.spacing[3]
  }
})
